import React from 'react';

const Hero = () => (
  <section className="herospace">
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-5 text-container">
          <h1>Identity Glossary</h1>
          <p>
            We've put together a glossary of terms for newcomers and seasoned developers alike to put any remaining confusion to rest.
          </p>
          <a href="javascript:signup()" className="btn btn-success btn-lg">Use Auth0 for Free</a>
        </div>
        <div className="col-xs-12 col-md-7 image-container">
          <img src="https://cdn.auth0.com/website/assets/pages/identity-glossary/img/glossary-e89fa246c0.png" alt="Identity Glossary" />
        </div>
      </div>
    </div>
  </section>
);

export default Hero;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/Hero/Hero.js